import {update, asyncUpdate, set, action} from "reduxigen";

export const loadBlogItems = asyncUpdate("blogItems", () => {
  return fetch(process.env.BLOG_URL + '/articles?_sort=created_at:desc', {
    method: "GET",
  })
  .then((data) => data.json())
  .then((data) => {
    return {
      blogItems: data
    }
  })
  .catch(error => {
    return {
      apiResponse: {
        error: true,
        message: error.message
      }
    }
  });

});

export const loadSingleBlogItem = asyncUpdate("currentBlogItem", (id) => {
  return fetch(process.env.BLOG_URL + '/articles/' + id, {
    method: "GET",
  })
  .then((data) => data.json())
  .then((data) => {
    return {
      currentBlogItem: data
    }
  })
  .catch(error => {
    return {
      apiResponse: {
        error: true,
        message: error.message
      }
    }
  });

});



// WEBPACK FOOTER //
// ./src/actions/BlogActions.js